import type {MouseEvent, PropsWithChildren} from 'react';
import styles from './internal-link.module.css';

type Props = PropsWithChildren<{
  readonly anchor: string;
}>;

export function PressReleaseHeaderInternalLink({anchor, children}: Props) {
  const handleSmoothScroll = (event: MouseEvent<HTMLAnchorElement>) => {
    const location = document.querySelector(`#${anchor}`);

    event.preventDefault();
    location?.scrollIntoView({behavior: 'smooth'});
  };

  return (
    <a
      href={`#${anchor}`}
      className={styles.link}
      onClick={(event) => {
        handleSmoothScroll(event);
      }}
    >
      {children}
    </a>
  );
}
